// @flow

import type { GoalId } from '../../types/GoalId';
import type { UserOnboarding } from '../../types/UserOnboarding';
import type {
  PopUserWeekdayAction,
  PushUserWeekdayAction, SetOnboardingUserEmail,
  SetOnboardingUserExperience, SetOnboardingUserFirstName,
  SetOnboardingUserGender,
  SetOnboardingUserGoal, SetOnboardingUserPassword,
  SetOnboardingUserSport, SetUserJourneyMailingAction, SetUserNewsletterAction, 
  SetUserOnboardingAction
} from '../../types/Action';
import {
  ONBOARDING_POP_WEEKDAY, ONBOARDING_PUSH_WEEKDAY, ONBOARDING_SET_EMAIL,
  ONBOARDING_SET_EXPERIENCE_ID, ONBOARDING_SET_FIRST_NAME,
  ONBOARDING_SET_GENDER_ID,
  ONBOARDING_SET_GOAL_ID, ONBOARDING_SET_JOURNEY_MAILING, ONBOARDING_SET_NEWSLETTER, ONBOARDING_SET_PASSWORD,
  ONBOARDING_SET_SPORT_ID,
  ONBOARDING_SET_USER_ONBOARDING
} from './types';
import type { SportId } from '../../types/SportId';
import type { ExperienceId } from '../../types/ExperienceId';
import type { GenderId } from '../../types/GenderId';
import type { WeekdayId } from '../../types/WeekdayId';

// eslint-disable-next-line import/prefer-default-export
export const setOnboardingActionCreators: {|
  popUserWeekday: (WeekdayId) => PopUserWeekdayAction,
  pushUserWeekday: (WeekdayId) => PushUserWeekdayAction,
  setUserEmail: (SyntheticEvent<HTMLInputElement>) => SetOnboardingUserEmail,
  setUserExperience: (ExperienceId) => SetOnboardingUserExperience,
  setUserFirstName: (SyntheticEvent<HTMLInputElement>) => SetOnboardingUserFirstName,
  setUserGender: (GenderId) => SetOnboardingUserGender,
  setUserGoal: (GoalId) => SetOnboardingUserGoal,
  setUserJourneyMailing: (boolean) => SetUserJourneyMailingAction,
  setUserNewsletter: (boolean) => SetUserNewsletterAction,
  setUserPassword: (SyntheticEvent<HTMLInputElement>) => SetOnboardingUserPassword,
  setUserSport: (SportId) => SetOnboardingUserSport,
  setUserOnboarding: (userOnboarding) => SetUserOnboardingAction,
|} = {
  popUserWeekday: (payload: WeekdayId) => ({ type: ONBOARDING_POP_WEEKDAY, payload }),
  pushUserWeekday: (payload: WeekdayId) => ({ type: ONBOARDING_PUSH_WEEKDAY, payload }),
  setUserEmail: (payload: SyntheticEvent<HTMLInputElement>) => ({ type: ONBOARDING_SET_EMAIL, payload }),
  setUserExperience: (payload: ExperienceId) => ({ type: ONBOARDING_SET_EXPERIENCE_ID, payload }),
  setUserFirstName: (payload: SyntheticEvent<HTMLInputElement>) => ({ type: ONBOARDING_SET_FIRST_NAME, payload }),
  setUserGender: (payload: GenderId) => ({ type: ONBOARDING_SET_GENDER_ID, payload }),
  setUserGoal: (payload: GoalId) => ({ type: ONBOARDING_SET_GOAL_ID, payload }),
  setUserJourneyMailing: (payload: boolean) => ({ type: ONBOARDING_SET_JOURNEY_MAILING, payload }),
  setUserNewsletter: (payload: boolean) => ({ type: ONBOARDING_SET_NEWSLETTER, payload }),
  setUserPassword: (payload: SyntheticEvent<HTMLInputElement>) => ({ type: ONBOARDING_SET_PASSWORD, payload }),
  setUserSport: (payload: SportId) => ({ type: ONBOARDING_SET_SPORT_ID, payload }),
  setUserOnboarding: (payload: UserOnboarding) => ({ type: ONBOARDING_SET_USER_ONBOARDING, payload }),
};
